import { queryCustomerGroupOfUser, scanPage } from '@/services/user';

export default {
  namespace: 'user',

  state: {
    hasLogin: false,
    pop: null,
    refresh: false,
    // 版本号
    version: '',
    // 来源
    origin: '',
    // 渠道
    channel: '',
    // 账号系统通用字段（4.5.5+）
    accountCommonFields: JSON.stringify({
      appId: '22017',
      appName: '网心云',
      clientVer: '999.9.9',
      deviceSign: 'c729abc06fcdeb31ebf18090fe13ee37',
      deviceName: 'evergo',
      deviceModel: '21091116AC',
      platType: '10',
      OSVer: '12',
      isp: 'NONE',
      netType: 'WIFI',
    }),
    // 打开页面操作：POP\PUSH
    pageAction: 'PUSH',
    customerGroup: 0,
    showNotificationTip: false,
  },

  effects: {
    *queryCustomerGroupOfUser({ payload, callback }, { call, put }) {
      const resp = yield call(queryCustomerGroupOfUser, payload);
      if (resp?.iRet === 0 && resp.data) {
        const { customerId } = resp.data;
        yield put({
          type: 'save',
          payload: {
            customerGroup: customerId,
          },
        });
        callback && callback(customerId);
      }
    },
    *scanPage({ payload, callback, failCallback }, { call, put }) {
      const resp = yield call(scanPage, payload);
      if (resp?.iRet === 0 && resp.data) {
        const { gr } = resp.data;
        callback && callback(gr);
      } else {
        failCallback && failCallback();
      }
    },
    *updateLoginState({ payload, callback }, { put }) {
      yield put({
        type: 'saveLoginState',
        payload,
      });
      callback && callback();
    },
    *updateRefreshState({ payload }, { put }) {
      yield put({
        type: 'saveRefreshState',
        payload: payload,
      });
    },
  },

  reducers: {
    save(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    saveLoginState(state, { payload }) {
      return {
        ...state,
        hasLogin: payload,
      };
    },
    saveRefreshState(state, { payload }) {
      return {
        ...state,
        refresh: payload,
      };
    },
    savePop(state, { payload }) {
      return {
        ...state,
        pop: payload,
      };
    },
    saveVersion(state, { payload }) {
      return {
        ...state,
        version: payload,
      };
    },
  },
};
